module.exports = __webpack_public_path__ + "static/fonts/gothamlight.7d5a4bc.woff2";